import { Checkbox, FormControlLabel } from "@mui/material";

export type checkItem = {
    label: string;
    checked: boolean;
};

export type FilterCheckItem = {
    title: string;
    toggleItem: Function;
    items: checkItem[];
};
const FilterCheckItem = ({ title, toggleItem, items }: FilterCheckItem) => {
    return (
        <div className="flex flex-col px-4 py-2 gap-3 my-2 mx-4 rounded bg-neutral-50 dark:bg-momeento-100">
            <h3 className="font-medium dark:text-white">{title}</h3>
            <div
                className="w-full flex flex-col items-start justify-start overflow-auto filter-items-container rounded bg-neutral-100 dark:bg-momeento-300 px-2 py-2"
                style={{ maxHeight: "40vh" }}
            >
                {items.map((i) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={i.checked}
                                onChange={() => toggleItem(i)}
                                size="small"
                            />
                        }
                        className="dark:text-white"
                        label={i.label}
                        key={i.label}
                    />
                ))}
            </div>
        </div>
    );
};

export default FilterCheckItem;
